/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Totp_Step_ScanInputs */



/**
* | output |
* | --- |
* | "Scan the code" |
*
* @param {Profile_Security_Totp_Step_ScanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_totp_step_scan = /** @type {((inputs?: Profile_Security_Totp_Step_ScanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Totp_Step_ScanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Code scannen")
	return /** @type {LocalizedString} */ ("Scan the code")
});